import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const PhoneRGB: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.6731 31.7115C28.5465 30.8449 26.9866 31.0182 26.0333 31.9715L22.8268 35.178C22.8268 35.178 19.967 34.2247 16.9339 31.2783C13.9008 28.3319 13.0342 25.2987 13.0342 25.2987L16.2407 22.0922C17.194 21.1389 17.3673 19.579 16.5007 18.4524L13.4676 14.466C12.601 13.3394 11.0411 12.9928 9.82778 13.7727C8.61448 14.5526 7.14128 15.5059 6.10138 16.4592C6.10138 16.4592 6.10138 16.4592 6.01468 16.5459C4.45478 18.1925 4.36808 20.5323 4.97478 22.6988C5.92808 25.9919 8.09458 30.325 12.9476 35.178C17.8006 40.031 22.2203 42.1975 25.4268 43.1508C27.5933 43.7574 29.9332 43.6708 31.5797 42.1109C31.5797 42.1109 31.5797 42.1109 31.6664 42.0242C32.6197 41.0709 33.6596 39.511 34.3529 38.2978C35.0462 37.0845 34.7862 35.5246 33.6596 34.658L29.6731 31.7115Z"
      fill="#002677"
    />
    <path
      d="M43.3654 26.0786C43.4521 20.2723 41.1989 14.726 37.1258 10.7396C33.3128 6.8398 28.2864 4.6733 22.9135 4.5C22.3069 4.5 21.7002 4.9333 21.7002 5.6266V5.7133C21.7002 6.3199 22.2202 6.8399 22.8268 6.8399C27.5931 7.0132 32.0995 9.0064 35.4793 12.3862C39.0324 15.9393 41.0256 20.7056 41.0256 25.8186C41.0256 25.9053 41.0256 25.9919 41.0256 26.0786V26.1653C41.1123 26.7719 41.5456 27.2919 42.1522 27.2919C42.7588 27.2918 43.2788 26.7718 43.3654 26.0786C43.3654 26.1652 43.3654 26.1652 43.3654 26.0786Z"
      fill="#FF612B"
    />
    <path
      d="M29.2397 18.5392C27.5065 16.806 25.2533 15.7661 22.9135 15.5927C22.3069 15.506 21.7002 16.026 21.7002 16.7193V16.806C21.7002 17.4126 22.1335 17.8459 22.7401 17.9326C24.56 18.1059 26.2932 18.8859 27.5931 20.1858C29.0663 21.659 29.9329 23.6522 29.9329 25.7321C29.9329 25.8188 29.9329 25.9921 29.9329 26.0787C29.9329 26.6853 30.4529 27.292 31.1462 27.292C31.7528 27.292 32.3595 26.772 32.3595 26.0787C32.3595 26.0787 32.3595 26.0787 32.3595 25.992C32.3595 23.2189 31.3196 20.5324 29.2397 18.5392Z"
      fill="#FF612B"
    />
    <path
      d="M37.8191 25.992C37.8191 21.659 36.2592 17.5859 33.2261 14.6394C30.453 11.8663 26.8132 10.3064 22.9135 10.0464C22.3069 10.0464 21.7002 10.5664 21.7002 11.173V11.2597C21.7002 11.8663 22.1335 12.2996 22.7401 12.3863C26.0332 12.5596 29.2397 13.9462 31.5795 16.286C34.0927 18.7992 35.4792 22.1789 35.4792 25.8187C35.4792 25.9054 35.4792 25.992 35.4792 26.0787V26.1654C35.5659 26.772 35.9992 27.292 36.6058 27.292C37.2124 27.292 37.7324 26.772 37.7324 26.1654C37.8191 26.0787 37.8191 26.0787 37.8191 25.992Z"
      fill="#FF612B"
    />
  </Box>
)
export default PhoneRGB
